import instanceSettingsApi from './instanceSettingsApi';

interface InstanceSettingRow {
  id: number;
  app: string;
  key: string;
  value: string;
  updatedAt: string;
  updatedBy: number | null;
}

// Returns all instance settings for a single app via GET /admin/settings/:app.
const getInstanceSettingsByApp = async (
  app: string
): Promise<InstanceSettingRow[]> => {
  try {
    const { data } = await instanceSettingsApi.get(`/${app}`);
    return data?.data ?? [];
  } catch (error) {
    console.error('[getInstanceSettingsByApp] Failed:', error);
    throw error;
  }
};

export default getInstanceSettingsByApp;
